import { useNavigate } from "react-router-dom";

import { Button } from "@/components/Button";
import { EmptyState } from "@/components/EmptyState";
import { useDocumentTitle } from "@/lib/useDocumentTitle";

/**
 * `/kalkulation` without a Vorgang. The register demo's stateless screens
 * have no Stand on the server to price, so step five only points the way
 * (design §9) — it does not pretend to have prices for a board that lives
 * in this browser alone. A locked screen, so the centred card with the mesh
 * sign, not a notice at the top of an empty page (Task 11, UX-Gutachten 1,
 * B-15).
 */
export function CalculationEntry() {
  useDocumentTitle("Kalkulation");

  const navigate = useNavigate();
  return (
    <EmptyState
      title="Kalkulation braucht einen gespeicherten Vorgang."
      actions={
        <Button variant="quiet" onClick={() => navigate("/")}>
          Zum Start
        </Button>
      }
    >
      Preise gibt es für einen Stand, der auf dem Server liegt. Öffne einen Vorgang von der Startseite — die
      Kalkulation ist dort sein vierter Schritt.
    </EmptyState>
  );
}
